var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.images.length)?_c('div',{staticClass:"featured-image component"},[(_vm.images[0])?_c('img',{attrs:{"src":_vm.images[0].src}}):_c('img',{attrs:{"src":"no-img.png"}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }